import React, { useState } from 'react'
import { useFormik } from 'formik'
import { toast } from 'react-toastify'
import * as Yup from 'yup'
import axios from 'axios'
import RPresults from './RPresults'
import ReactModal from 'react-modal'
import DocumentParserModal from './DocumentParserModal'
interface IProps {
  setLoadResultsFlag: any
  setShortlistedProfiles: any
  openWhatsapptModal1: any
}

interface IProps {
  setLoadResultsFlag: any
  setShortlistedProfiles: any
}

const initialValues = {
  mandatorySkills: '',
  optionalSkills: '',
  yearsOfExperienceFrom: 0,
  yearsOfExperienceTo: 0,
  matchPercentage: 0,
  files: []
}
const parserSchema = Yup.object().shape({
  mandatorySkills: Yup.string()
    .min(3, 'Minimum 3 symbols')
    .max(50, 'Maximum 50 symbols')
    .required('Mandatory skills are required'),
  /* files: Yup.array().min(1, "at least one file is required"), */
  /* file: Yup.mixed().required('File is required'), */
  matchPercentage: Yup.number()
    .min(1, 'cannot be a negative number')
    .max(100, 'cannot be more than 100%')
    .required()
})

const RPform: React.FC<IProps> = ({
  setLoadResultsFlag,
  setShortlistedProfiles,
  openWhatsapptModal1
}) => {
  const [loadingOl, setLoading] = useState(false)
  const [status, setStatus] = useState('')
  const [submitting, setSubmitting] = useState(false)
  const [theFiles, setTheFiles] = useState<any>([])

  let uploadedFiles: any = []

  const submitForm = async (val: any) => {
    const promise = new Promise((resolve, reject) => {
      console.log('resolved with ', resolve)
      console.log('rejected with ', reject)
    })
    console.log('resume parser form submitted with payload ', val)
    try {
      const formData = new FormData()
      formData.append('must_have_skills', val.variables.input.mandatorySkills)
      formData.append('optional_skills', val.variables.input.optionalSkills)
      formData.append(
        'experience',
        `${val.variables.input.yearsOfExperienceFrom}-${val.variables.input.yearsOfExperienceTo}`
      )
      formData.append('accuracy', String(val.variables.input.matchPercentage))
      // Ensure that values.files is an array before attempting to iterate
      if (Array.isArray(theFiles)) {
        // Append each file to FormData
        theFiles.forEach((file: any) => {
          formData.append('file', file)
        })
      }
      formData.append('email', 'testmail@test.com')
      const response = await axios
        .post(`${process.env.REACT_APP_RESUME_PARSER_URL}/resume_parser/parse`, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
            'x-rapidapi-host': 'file-upload8.p.rapidapi.com',
            'x-rapidapi-key': 'your-rapidapi-key-here'
          }
        })
        .then((res) => {
          setShortlistedProfiles(res)
          setLoadResultsFlag(true)
        })
      console.log(response)
      // Set any status or perform actions based on the response
    } catch (error) {
      // Handle errors
      console.error('Error making the POST request:', error)
      // Set any status or perform actions based on the error
      setStatus('Error submitting the form')
    } finally {
      // Set submitting to false to enable the form again
      setSubmitting(false)
    }
    return promise
  }

  const handleFileUpload = (event: any) => {
    formik.handleChange(event)
    for (let i = 0; i < event.target.files.length; i++) {
      uploadedFiles.push(event.target.files[i])
    }
    console.log('Uploaded file:', uploadedFiles)
    setTheFiles(uploadedFiles)
  }

  const formik = useFormik({
    initialValues,
    validationSchema: parserSchema,
    onSubmit: (values, { setStatus, setSubmitting }) => {
      console.log(theFiles)
      setLoading(true)

      submitForm({
        variables: {
          input: {
            mandatorySkills: values.mandatorySkills,
            optionalSkills: values.optionalSkills,
            yearsOfExperienceFrom: values.yearsOfExperienceFrom,
            yearsOfExperienceTo: values.yearsOfExperienceTo,
            matchPercentage: values.matchPercentage,
            files: uploadedFiles
          }
        }
      })
        .then((res: any) => {
          if (res.data.signIn.status === 200) {
            toast.success('received success response against resume parser form submission!')
            /* setLoading(false) */
            document.location.reload()
          } else {
            /* setLoading(false) */
            toast.error(res.data.signIn.message)
            setSubmitting(false)
          }
        })
        .catch((err: any) => {
          /* setLoading(false) */
          setSubmitting(false)
          console.error(err)
        })
    }
  })

  return (
    <div className='container mt-8'>
      <div className='card-title justify-content-center align-center w-100'>
        <div className='d-flex flex-column flex-column-fluid bgi-position-y-bottom position-x-center bgi-no-repeat bgi-size-contain bgi-attachment-fixed'>
          <div className='d-flex flex-center flex-column flex-column-fluid p-6 pb-lg-20'>
            <div
              className='w-lg-800px rounded shadow mx-auto'
              style={{ position: 'relative', overflow: 'hidden' }}
            >
              <div
                className='content-wrapper bg-white p-10 p-lg-15'
                style={{ position: 'relative' }}
              >
                <form
                  className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework'
                  noValidate
                  id='kt_login_signup_form'
                  onSubmit={formik.handleSubmit}
                >
                  {formik.status ? (
                    <div className='mb-lg-15 alert alert-danger'>
                      {' '}
                      <div className='alert-text font-weight-bold'>{formik.status}</div>{' '}
                    </div>
                  ) : (
                    <div></div>
                  )}

                  <div className='position-relative mb-8'>
                    <h1 className='text-center'>The Resume Parser</h1>
                    <a
                      onClick={(e) => {
                        e.preventDefault() // Prevent default link behavior
                        openWhatsapptModal1()
                      }}
                      className='position-absolute top-0 end-0 text-primary fs-6 text-decoration-none cursor-pointer'
                      style={{ marginTop: '10px' }}
                    >
                      Document Parser
                    </a>
                  </div>

                  <label className='form-label fs-4 required '>Mandatory Skills</label>
                  <input
                    placeholder='Add some mandatory skills'
                    type='text'
                    className='form-control form-control-lg form-control-solid mb-5'
                    id='mandatorySkills'
                    name='mandatorySkills'
                    onChange={formik.handleChange}
                    value={formik.values.mandatorySkills}
                  />

                  {formik.touched.mandatorySkills && formik.errors.mandatorySkills && (
                    <div className='fv-plugins-message-container text-danger'>
                      <span role='alert'>{formik.errors.mandatorySkills}</span>
                    </div>
                  )}

                  <br />
                  <label className='form-label fs-4 required'>Optional Skills</label>
                  <input
                    placeholder='Add some more skills'
                    type='text'
                    autoComplete='on'
                    className='form-control form-control-lg form-control-solid'
                    id='optionalSkills'
                    name='optionalSkills'
                    onChange={formik.handleChange}
                    value={formik.values.optionalSkills}
                  />

                  <div className='fv-row my-7'>
                    <div className='clearfix'>
                      <div className='w-25 mx-2 float-start'>
                        <label className='form-label fs-4 required'>Years of Experience</label>
                      </div>
                    </div>
                    <br />
                    <div className='clearfix'>
                      <div className={`w-25 mx-2 float-start`}>
                        <label className='form-label fs-6'>From</label>
                        <input
                          type='number'
                          min='0'
                          className='form-control form-control-lg form-control-solid'
                          id='yearsOfExperienceFrom'
                          name='yearsOfExperienceFrom'
                          onChange={formik.handleChange}
                          value={formik.values.yearsOfExperienceFrom}
                        />
                      </div>
                      <div className={`w-25 mx-2 float-start`}>
                        <label className='form-label s-6'>To</label>
                        <input
                          type='number'
                          min='0'
                          className='form-control form-control-lg form-control-solid'
                          id='yearsOfExperienceTo'
                          name='yearsOfExperienceTo'
                          onChange={formik.handleChange}
                          value={formik.values.yearsOfExperienceTo}
                        />
                      </div>
                      <div className='w-25 mx-2 float-end'>
                        <label className='form-label fs-5 required'>Match Percentage %</label>
                        <input
                          type='number'
                          min='0'
                          max='100'
                          className='form-control form-control-lg form-control-solid'
                          id='matchPercentage'
                          name='matchPercentage'
                          onChange={formik.handleChange}
                          value={formik.values.matchPercentage}
                        />
                      </div>
                      {formik.touched.matchPercentage && formik.errors.matchPercentage && (
                        <div className='fv-plugins-message-container text-danger'>
                          <span role='alert'>{formik.errors.matchPercentage}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className='fv-row mb-7'>
                    <label className='form-label fs-4 required'>Upload Your Resume </label>
                    <div className='mb-3'>
                      <input
                        className='form-control'
                        type='file'
                        multiple
                        /* accept='.pdf' */
                        id='files'
                        name='files'
                        onChange={handleFileUpload}
                        value={formik.values.files}
                      />
                    </div>

                    {formik.touched.files && formik.errors.files && (
                      <div className='fv-plugins-message-container text-danger'>
                        <span role='alert'>{formik.errors.files}</span>
                      </div>
                    )}
                  </div>

                  <div className='text-center my-2'>
                    <button
                      style={{ color: 'white', backgroundColor: '#009ef7' }}
                      type='submit'
                      className='btn btn-lg btn-primary w-100'
                      /* disabled={formik.isSubmitting || !formik.isValid} */
                    >
                      {!loadingOl && <span className='indicator-label'>Submit</span>}
                      {loadingOl && (
                        <span className='indicator-progress' style={{ display: 'block' }}>
                          Please wait...
                          <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                        </span>
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

const ResumeParser = () => {
  const [loadResultsFlag, setLoadResultsFlag] = useState<any>(false)
  const [shortlistedProfiles, setShortlistedProfiles] = useState<any>({})
  const [isWhatsappModalOpen1, setIsWhatsappModalOpen1] = useState<boolean>(false)

  const openWhatsapptModal1 = () => {
    setIsWhatsappModalOpen1(true)
  }

  const afterOpenWhatsapptModal1 = () => {
    // Add any logic that needs to run after the modal is opened
  }

  const closeWhatsappModal1 = () => {
    setIsWhatsappModalOpen1(false)
  }
  const customWhatsappModalStyles1: ReactModal.Styles = {
    content: {
      top: '50%',
      left: '50%',
      right: 'auto',
      bottom: 'auto',
      marginRight: '-50%',
      transform: 'translate(-40%, -50%)'
    }
  }

  return (
    <>
      {loadResultsFlag ? (
        <RPresults results={shortlistedProfiles} setLoadResultsFlag={setLoadResultsFlag} />
      ) : (
        <RPform
          setLoadResultsFlag={setLoadResultsFlag}
          setShortlistedProfiles={setShortlistedProfiles}
          openWhatsapptModal1={openWhatsapptModal1}
        />
      )}

      <ReactModal
        isOpen={isWhatsappModalOpen1}
        onAfterOpen={afterOpenWhatsapptModal1}
        onRequestClose={closeWhatsappModal1}
        style={customWhatsappModalStyles1}
        contentLabel='Whatsapp'
      >
        <DocumentParserModal closeWhatsappModal1={closeWhatsappModal1} />
      </ReactModal>
    </>
  )
}

export default ResumeParser
